module.exports = __webpack_public_path__ + "static/media/Public_11.04eeeb31.jpg";